import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './redux/reducers/auth';
import orgReducer from './redux/reducers/org';
import userReducer from './redux/reducers/user';
import progressReducer from './redux/reducers/progress';
import uiReducer from './redux/reducers/ui';
import scenarioReducer from './redux/reducers/scenario';
import homeReducer from './redux/reducers/home';
import appReducer from './redux/reducers/app';
import jobReducer from './redux/reducers/job';
import preferenceReducer from './redux/reducers/preference';

// Combine all reducers
const appReducers = combineReducers({
  auth: authReducer,
  org: orgReducer,
  user: userReducer,
  progress: progressReducer,
  scenario: scenarioReducer,
  ui: uiReducer,
  home: homeReducer,
  // dictionary: dictionaryReducer,
  app: appReducer,
  job: jobReducer,
  preference: preferenceReducer,
});

// Root reducer with reset on logout
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return appReducers(state, action);
};

// Create store with RTK's configureStore
// - thunk middleware included by default
// - DevTools enabled by default in development
export const store = configureStore({
  reducer: rootReducer,
  devTools: {
    trace: true,
    traceLimit: 25,
  },
});
